/*
    sidebar component should be a component usable for all main views
*/
import React, { useEffect, useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import { $, Foundation } from "../../../../../vendor";
import Biscuit from "../../../../utils/Biscuit";
import SidebarMenu from "../../reservations/components/SidebarMenu";
import { getApiHost } from "../../../../Sync";
import { getAllUrlParams } from "../../../../utils";
import * as FileSaver from "../../../../../vendor/FileSaver";
import NewVoucherButton from "./NewVoucherButton";

const VoucherSidebar = (props) => {
  const { setAdd, resetFilter, filter, setFilter, filterChangedHandle } = props;
  let language = Biscuit.get("user.lang").replace("-", "_");

  let tempData = [{ id: "all", name: t("all") }];

  let contingents = props.contingents;

  tempData = [{ id: "all", name: t("all") }];
  for (let index = 0; index < contingents.length; index++) {
    tempData.push(contingents[index]);
  }
  contingents = tempData;

  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  let countParams = getAllUrlParams(window.location.href);
  countParams?.type !== undefined && delete countParams.type;
  console.log("countParams", countParams);
  const cleanState = { contingentFilter: false, statusFilter: false };
  const [usedFilterCount, setUsedFilterCount] = useState({
    contingentFilter: allUrlParams?.contingent_id !== undefined ? true : false,
    statusFilter: allUrlParams?.status !== undefined ? true : false,
  });
  const [filterCount, setFilterCount] = useState(
    Object.keys(countParams).length > 0 ? Object.keys(countParams).length : 0,
  );
  const [contingentFilter, setContingentFilter] = useState(
    searchParams.get("contingent_id") !== null ? searchParams.get("contingent_id") : "all",
  );

  const [statusFilter, setStatusFilter] = useState(
    searchParams.get("status") !== null ? searchParams.get("status") : "all",
  );

  const [_resetFilter, _setResetFilter] = useState(resetFilter);
  const [globalFilter, setGlobalFilter] = useState({}); // set empty object, there are no filters set by default

  useEffect(() => {
    if (!_resetFilter) return;

    if (_resetFilter) {
      resetFilter(false);
    }
    _setResetFilter(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_resetFilter]);

  const handleChangeTo = (value) => {
    var globalClone = {};

    // update global filter
    Object.assign(globalClone, globalFilter); // get current values of global filter (all filter)

    setGlobalFilter(globalClone);
    props.filterChangedHandle(globalClone); // cloned object must be used because global filter is not yet updated
  };

  const onFilterCountChangeHandle = (value) => {
    let clone = { ...value };
    let count = 0;
    for (const [type, val] of Object.entries(clone)) {
      if (val) {
        count++;
      }
    }
    if (count < 1) {
      count = 0;
      $("#inb-selected-filters").addClass("hidden");
    } else {
      $("#inb-selected-filters").removeClass("hidden");
    }
    setFilterCount(count);
  };

  const resetFilterA = (dispatch = true) => {
    let clone = {
      find: "CheckedInStatus",
    };
    setStatusFilter("all");
    setContingentFilter("all");
    setFilterCount(0);
    setGlobalFilter(clone);
    setUsedFilterCount(cleanState);
    onFilterCountChangeHandle(cleanState);
    if (dispatch) {
      filterChangedHandle(clone, {});
    } else {
      setFilter(clone);
    }
    const newRelativePathQuery = window.location.pathname;
    history.pushState(null, "", newRelativePathQuery);
  };

  const onContingentFilterChange = (val) => {
    if (val === "all" || typeof val.target === "undefined") {
      val = { target: { value: "all" } };
    }
    setContingentFilter(val.target.value); // set status filter
    let clone = { ...props.filter };
    let clone2 = { ...usedFilterCount }; // get current filter settings (all filter)

    if (val.target.value !== "all") {
      // add status filter to global filter
      clone.contingent_id = val.target.value;
      clone2.contingentFilter = true;
      searchParams.set("contingent_id", val.target.value);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      // remove status filter from global filter
      delete clone["contingent_id"];
      clone2.contingentFilter = false;
      searchParams.delete("contingent_id");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    setUsedFilterCount(clone2);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(clone2);
    props.filterChangedHandle(clone); // cloned object must be used because global filter is not yet updated
  };

  const onStatusFilterChange = (val) => {
    if (val !== "inprogress") {
      setStatusFilter(val); // set status filter
    } else {
      setStatusFilter(val);
    }
    let clone = { ...filter };
    let clone2 = { ...usedFilterCount }; // get current filter settings (all filter)

    if (val !== "all" && val !== null && val !== "inprogress") {
      // add status filter to global filter
      if (clone["find"] === "inprogress") {
        delete clone["find"];
      }
      clone.status = val;
      clone2.statusFilter = true;
    } else if (val === "inprogress") {
      delete clone["status"];
      clone["find"] = val;
      clone2.statusFilter = true;
    } else {
      // remove status filter from global filter
      delete clone["status"];
      if (clone["find"] === "inprogress") {
        delete clone["find"];
      }
      clone2.statusFilter = false;
      setStatusFilter("all");
    }
    setUsedFilterCount(clone2);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(clone2);
    props.filterChangedHandle(clone); // cloned object must be used because global filter is not yet updated
    if (val !== "all" && val !== null && val !== "inprogress") {
      searchParams.delete("find");
      searchParams.set("status", val);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else if (val === "inprogress") {
      searchParams.delete("status");
      searchParams.set("find", val);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      searchParams.delete("find");
      searchParams.delete("status");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
  };

  const onToggleLeftBar = (ev) => {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  };

  let _dropdown = null;

  const _initDropdown = (ev) => {
    ev.preventDefault();

    if (_dropdown === null) {
      _dropdown = new Foundation.Dropdown($("#inb-c-sidebar .inb-dropdown"));
    }
    _dropdown.open();

    return false;
  };

  // ****************************************************************************** filter location select *************************************************************

  const addVoucher = () => {
    console.log("addResource Sidebar");
    setAdd(true);
  };

  const _export = () => {
    let params = "",
      count = 0;
    let clone = { ...globalFilter };
    for (const [type, val] of Object.entries(clone)) {
      if (count > 0) {
        params += "&" + type + "=" + val;
      } else {
        params += "?" + type + "=" + val;
      }
      count++;
    }

    const xmlHttp = new XMLHttpRequest();

    xmlHttp.open("GET", getApiHost() + "/resources/export" + params, true);

    //  xmlHttp.setRequestHeader('Accept', 'application/json')
    xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
    xmlHttp.setRequestHeader("Content-Language", language);
    xmlHttp.setRequestHeader("Accept-Language", language);
    xmlHttp.responseType = "blob";

    xmlHttp.onload = function () {
      const blob = new Blob([xmlHttp.response], { type: "application/xls" });
      FileSaver.saveAs(blob, t("resources") + ".xlsx");
    };

    xmlHttp.send(null);
  };

  const ClickHandler = (value) => {
    if (value === "export-xls") {
      _export();
    }
  };

  const getMenu = () => {
    return [
      {
        text: t("export_xls", null, "capital"),
        href: "#",
        iconClass: "ico-inb inb-fi-excel",
        rel: "noopener noreferrer",
        title: "export-xls",
        id: "export-xls",
        handler: ClickHandler,
      },
      {
        spacer: true,
      },
    ];
  };

  return (
    <>
      <aside id="inb-c-sidebar" className="reservations-sidebar" style={{ float: "left" }}>
        <header className="inb-c-left-bar__title sticky-top">
          <h1 className="inb-page-title">{props.heading}</h1>
          <SidebarMenu menu={getMenu()} />
        </header>
        <div className="sticky-top-filter">
          <aside id="inb-selected-filters">
            {filterCount > 0 && (
              <ul>
                <p>
                  <i className="fi fi-filter"></i>
                  <span id="inb-selected-filters__count">{" " + filterCount}</span>

                  {" " + t("filter_selected")}
                  <a
                    href="#"
                    id="inb-selected-filters__unset"
                    className="unset-filter"
                    title={t("unselect_all_filter")}
                    onClick={() => {
                      resetFilterA(true);
                    }}
                  >
                    x
                  </a>
                </p>
              </ul>
            )}
          </aside>
          <ul>&nbsp;</ul>
          {/*<SidebarFilter
                    id="inb-c-left-bar-flist--resources-main"
                    heading=""
                    type="list"
                    data={
                        getFilterData(  [
                            {name: t('all'), summaryItem: "allCount", value: 'all'},
                            {name: t('active'), summaryItem: "activeCount", value: 'active'},
                            {name: t('defect'), summaryItem: "defectCount", value: 'defect'},
                            {name: t('inactive'), summaryItem: "inactiveCount", value: 'inactive'},
                            {name: t('inprogress', null,'capital'), summaryItem: "inprogressCount", value: 'inprogress'}
                        ], props.summaryPending, props.summary)
                    }
                    dataKey="value"
                    selected={statusFilter}
                    summaryPending={props.summaryPending}
                    onChangeHandle={onStatusFilterChange}/>*/}
          {/* {props.summaryPending && <>
                <div className="inb-image-box">
                    <img className="rollingLoader" src="assets/img/rolling_loader.svg"/>
                </div>
            </>*/}

          {/*  <ul>
                <span className="inb-list-title">
                    {t('vouchers',null,'capital')}
                </span>
               <div className={"inbooma-select-box" + (locationFilterState.isOpen ? '' : ' close')} style={{zIndex: '0'}}>
                    <input className="inbooma-select-box__input" placeholder={t('select_${a}',{a:t('location',null,'capital')})} value={location == null ? locationFilterState.value : location.name}
                           style={(location !== undefined && location != null) ? {background: '#fff',border: '1px solid #e3e3e3',padding: '0.5rem',fontSize: '0.9rem',color: '#3b3b3b',paddingRight:'20px'} : {}}
                           onClick={() => {setLocationFilterState({...locationFilterState, isOpen : true})}}
                           onBlur={() => {setLocationFilterState({...locationFilterState, isOpen : false})}}
                           onChange={(e) => {queryLocationFilterSelectHandle(e)}} />
                    {location !== undefined && location !== null &&
                    <a href="#" className="inbooma-select-box__reset" onClick={() => locationFilterSelectHandle(undefined)} style={{float:'unset', paddingLeft:'15px'}}>
                        x
                    </a>
                    }
                    {_locationsResults.success === true &&
                    <ul className={"inbooma-select-box-results" + (locationFilterState.isOpen ? '' : ' hidden')} style={{width:'25rem'}}>
                        {_locationsResults.data.map((loc,index) => {
                            return (
                                <li className={"inbooma-select-box-results__field" + (typeof location !== 'undefined' && location != null && location.id == loc.id ? ' selected' : '')}
                                    key={loc.id} value={loc.name}
                                    onClick={() => { locationFilterSelectHandle(loc) }}>
                                    <span style={{paddingRight:'10px'}}>{loc.name}</span>
                                </li>
                            );
                        })}
                    </ul>}
                </div>
            </ul>
            <ul id="inb-c-left-bar-flist--resource-contingent"
                className="inb-vert-list">
                <span className="inb-list-title">
                    {t('contingent',null,'capital')}
                </span>
                <select
                    className="inbooma-select-box__input"
                    name="contingents"
                    onChange={(e) => onContingentFilterChange(e)}
                    value={contingentFilter}
                    placeholder={t('select_${a}',{a:t('contingent')})}>
                    {contingents.map(contingent => {
                        return(
                            <>
                                <option key={contingent.id} value={contingent.id}>{contingent.name}</option>
                            </>
                        )
                    })}
                </select>
                {contingentFilter !== undefined && contingentFilter !== null &&
                <a href="#" className="inbooma-select-box__reset" onClick={() => onContingentFilterChange('all')} style={{float:'unset', paddingLeft:'15px'}}>
                    x
                </a>
                }
            </ul>*/}
        </div>
        <footer
          className="inb-c-left-bar__footer small-only-float-container"
          data-inb-action-link="write"
        >
          <a
            href="#"
            id="toggle-left-bar"
            className="button secondary show-for-small-only"
            onClick={(e) => onToggleLeftBar(e)}
          >
            <i className="fi fi-filter"></i>
            <span className="show-for-sr">{t("open_filter_menu")}</span>
          </a>
          {rbac.hasPermission("write") && (
            <NewVoucherButton addVoucher={addVoucher} currentUrl={currentUrl} />
          )}
        </footer>
      </aside>
    </>
  );
};

export default VoucherSidebar;
